module.exports = __webpack_public_path__ + "static/media/17-helio-chagas.b91faae8.webp";